import { EngineerValidateSuccess, Stub } from '@/shared';
import { OperationAlertProps } from './alert.types';

export const DetailsIssuedAlert = ({ productTechMapNumber, variant = 'product' }: OperationAlertProps) => {
	const variantName = {
		assembly: 'сборочной',
		preform: 'заготовительной',
		product: '',
		rubber: '',
	};

	return (
		<Stub
			icon={<EngineerValidateSuccess />}
			header="Детали выданы"
			label={
				<p>
					Информация по выдаче деталей для {variantName[variant]} маршрутной карты{' '}
					<strong>№{productTechMapNumber}</strong> успешно сохранена
				</p>
			}
		/>
	);
};
